(() => {
  "use strict";

  /*
   * This script is visual only.
   * It does not validate, block or redirect checkout.
   */

  const TRUST_LINE_CLASS =
    "zyron-cart-trust-line";

  let updateQueued = false;

  function getCheckoutButtons(root = document) {
    return Array.from(
      root.querySelectorAll(
        [
          'button[name="checkout"]',
          ".cart__checkout-button",
          'input[name="checkout"]'
        ].join(",")
      )
    );
  }

  function createTrustLine() {
    const line =
      document.createElement("p");

    line.className =
      TRUST_LINE_CLASS;

    line.innerHTML = `
      <span
        class="zyron-cart-trust-icon"
        aria-hidden="true"
      >
        ✓
      </span>

      <span>
        Secure checkout • Fast digital delivery
      </span>
    `;

    return line;
  }

  function addTrustLine(button) {
    if (!button) return;

    const parent =
      button.parentElement;

    if (!parent) return;

    const existing =
      parent.querySelector(
        `.${TRUST_LINE_CLASS}`
      );

    if (existing) return;

    button.insertAdjacentElement(
      "afterend",
      createTrustLine()
    );
  }

  function enhanceCheckoutButton(button) {
    if (
      !button ||
      button.dataset.zyronEnhanced ===
        "true"
    ) {
      return;
    }

    button.dataset.zyronEnhanced =
      "true";

    /*
     * Keep the original Shopify checkout
     * behavior completely unchanged.
     */
    addTrustLine(button);
  }

  function enhanceCartDrawer() {
    const drawer =
      document.querySelector(
        "cart-drawer"
      ) ||
      document.querySelector(
        ".cart-drawer"
      );

    if (!drawer) return;

    drawer.classList.add(
      "zyron-cart-enhanced"
    );

    getCheckoutButtons(
      drawer
    ).forEach(
      enhanceCheckoutButton
    );
  }

  function enhanceCartPage() {
    const cartItems =
      document.querySelector(
        "#main-cart-items"
      );

    const cartFooter =
      document.querySelector(
        "#main-cart-footer"
      );

    if (!cartItems && !cartFooter) {
      return;
    }

    document.body.classList.add(
      "zyron-cart-page"
    );

    if (cartFooter) {
      getCheckoutButtons(
        cartFooter
      ).forEach(
        enhanceCheckoutButton
      );
    }
  }

  function enhanceAllCarts() {
    enhanceCartDrawer();
    enhanceCartPage();
  }

  function queueEnhancement() {
    if (updateQueued) return;

    updateQueued = true;

    window.requestAnimationFrame(
      () => {
        updateQueued = false;
        enhanceAllCarts();
      }
    );
  }

  document.addEventListener(
    "DOMContentLoaded",
    enhanceAllCarts
  );

  /*
   * Shopify redraws the cart drawer whenever
   * a quantity or cart item changes.
   */
  const observer =
    new MutationObserver(
      queueEnhancement
    );

  observer.observe(
    document.documentElement,
    {
      childList: true,
      subtree: true
    }
  );

  enhanceAllCarts();
})();